import { RouteObject } from 'react-router-dom';
import { AdminActivity } from './AdminActivity/AdminActivity';
import { AdminLayout } from './AdminLayout';



export const root: RouteObject = {
  path: 'admin',
  element: (<AdminLayout />),
  children: [{
    path: '',
    element: <AdminActivity />
  }]
};
